import React from 'react'
import InsertChart from '@mui/icons-material/InsertChart'
import { downloadUserReportCsv } from '../helpers/downloadUserReportCsv'
import DownloadSplitActionButton from '../../../components/action_button/DownloadSplitActionButton'

export default function ChargesCsvDownloadMenu({
  startDate,
  endDate,
  searchQuery,
  activeTab,
  hasPendingSettlementQuery = ''
}) {
  const runDownload = async (csvType, filenameLabelOverride) => {
    await downloadUserReportCsv({
      csvType,
      startDate,
      endDate,
      searchQuery,
      activeTabKey: activeTab,
      filenameLabelOverride,
      hasPendingSettlementQuery
    })
  }

  return (
    <DownloadSplitActionButton
      text="Descargar"
      density="card"
      fullWidth
      onPrimaryClick={() => runDownload('charges')}
      menuItems={[
        {
          label: 'Reporte de cobros',
          onClick: () => runDownload('charges'),
          icon: <InsertChart fontSize="small" />
        },
        {
          label: 'Reporte de actividades - Todos los usuarios',
          onClick: () => runDownload('charges_activity', 'Actividades'),
          icon: <InsertChart fontSize="small" />
        }
      ]}
    />
  )
}
